/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Earningsoutstanding1Inputs */

const en_earningsoutstanding1 = /** @type {(inputs: Earningsoutstanding1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Still to be paid out`)
};

const de_earningsoutstanding1 = /** @type {(inputs: Earningsoutstanding1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch auszuzahlen`)
};

/**
* | output |
* | --- |
* | "Still to be paid out" |
*
* @param {Earningsoutstanding1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const earningsoutstanding1 = /** @type {((inputs?: Earningsoutstanding1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Earningsoutstanding1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_earningsoutstanding1(inputs)
	return de_earningsoutstanding1(inputs)
});
export { earningsoutstanding1 as "earningsOutstanding" }